<template>
  <v-app>
    <v-container class="py-2 px-0 header" fluid>
      <StaticHeader />
    </v-container>
    <v-main class="main" fluid>
      <StaticMenu />
      <v-container class="pa-0">
        <router-view />
      </v-container>
    </v-main>
    <v-footer class="white" paddless>
      <v-container class="pa-0" fluid>
        <Footer />
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import StaticHeader from "@/components/StaticHeader.vue";
import StaticMenu from "@/components/StaticMenu.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    StaticHeader,
    StaticMenu,
    Footer
  }
};
</script>

<style>
@import url("/assets/styles/colors.css");

/* @font-face {
  font-family: nunito_sans;
  src: url(C:/develop/E4W/Vuetify/glsexpresswebapp/src/assets/fonts/Nunito_Sans/NunitoSans-Regular.ttf);
}

@font-face {
  font-family: nunito_sans;
  src: url(C:/develop/E4W/Vuetify/glsexpresswebapp/src/assets/fonts/Nunito_Sans/NunitoSans-Bold.ttf);
  font-weight: bold;
}

@font-face {
  font-family: nunito_sans;
  src: url(C:/develop/E4W/Vuetify/glsexpresswebapp/src/assets/fonts/Nunito_Sans/NunitoSans-Italic.ttf);
  font-style: italic;
} */

@font-face {
  font-family: newson_gls;
  src: url(C:/develop/E4W/Vuetify/glsexpresswebapp/src/assets/fonts/NewsonGLS_WEB_woff/NewsonGLS-WEB-Light.woff);
}

@font-face {
  font-family: newson_gls;
  src: url(C:/develop/E4W/Vuetify/glsexpresswebapp/src/assets/fonts/NewsonGLS_WEB_woff/NewsonGLS-WEB-Regular.woff);
  font-weight: bold;
}

@font-face {
  font-family: newson_gls;
  src: url(C:/develop/E4W/Vuetify/glsexpresswebapp/src/assets/fonts/NewsonGLS_WEB_woff/NewsonGLS-WEB-LightItalic.woff);
  font-style: italic;
}

#app {
  font-family: newson_gls;
  font-size: 12px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  text-align: left;
}

.header {
  background-color: var(--GLS-blue-100);
  color: var(--GLS-white);
}

.main {
  max-width: 870px;
  margin: auto;
}

.v-card__title {
  font-size: 12pt !important;
  height: 50px !important;
  align-content: center !important;
}

.v-text-field .v-input__control .v-input__slot,
.v-text-field .v-input__control .v-input {
  min-height: 30px !important;
  max-height: 30px !important;
  font-size: 8pt !important;
  display: flex !important;
  align-items: center !important;
}

/* help icons */
.v-text-field.v-input.v-text-field .v-input__append-outer,
.v-input--selection-controls > .v-input__append-outer {
  margin-top: 3px !important;
}

.v-select.v-text-field.v-input.v-text-field .v-input__append-outer {
  margin-top: 5px !important;
}

/* inner and outer icons; clear, dropdown etc. */
.v-text-field.v-input.v-text-field .v-input__append-inner {
  margin-top: 3px !important;
}

.v-select.v-text-field.v-input.v-text-field .v-input__append-inner {
  margin-top: 7px !important;
}

.v-autocomplete.v-text-field.v-input.v-text-field .v-input__append-inner {
  margin-top: 3px !important;
}

.v-application .info--text {
  font-size: 15pt !important;
}

/* label position and size */
.v-text-field.v-input .v-label {
  top: 7px !important;
  font-size: 8pt !important;
}

.v-select.v-text-field.v-input .v-label {
  top: 11px !important;
  font-size: 8pt !important;
}

.v-autocomplete.v-text-field.v-input .v-label {
  top: 7px !important;
  font-size: 8pt !important;
}

.v-text-field.v-input .v-label--active {
  transform: translateY(-16px) scale(0.9) !important;
  margin-left: -5px;
}

/* removes border on all inputs */
.v-text-field--outlined fieldset {
  border: 0px solid !important;
  font-size: 8pt !important;
}

/* custom class for icons */
.navigation-icon {
  color: var(--GLS-blue-100) !important;
  min-height: 45px;
  max-height: 45px;
}

/* removes background on clicked/active icons */
.v-icon:after {
  background-color: transparent !important;
}

/* buttons */
.v-btn {
  background-color: var(--alt-blue) !important;
  color: var(--GLS-white) !important;
}

.v-btn__content {
  font-size: 12px !important;
  padding: 0px !important;
}

/* buttons inverted / text */
.v-btn--flat,
.v-btn--outlined,
.v-btn--text {
  background-color: transparent !important;
  color: var(--alt-blue) !important;
}

/* errormessages */
.v-messages {
  font-size: 8pt !important;
  margin-left: -5px !important;
}

.v-text-field.v-text-field .v-text-field__details {
  margin-bottom: 0px !important;
}

/* checkboxes */
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 4px !important;
}

.v-input--selection-controls .v-messages {
  /* removes errormessages from checkbox => gap under checkbox */
  min-height: 0px !important;
  max-height: 0px !important;
}
.v-input--selection-controls__input .v-icon:before {
  background-color: transparent !important;
  color: var(--alt-blue) !important;
  font-size: 15pt;
}

.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 8pt !important;
  padding-top: 3px !important;
}

.v-input--selection-controls__ripple,
.v-input--selection-controls__input,
.v-input--selection-controls__input:before,
.v-input--selection-controls__input:after,
.v-input--selection-controls__ripple:before,
.v-input--selection-controls__ripple:after {
  background-color: transparent !important;
  color: transparent !important;
}

/* combobox and selectbox */
.combobox-styled .v-list {
  padding: 0 !important;
  text-align: left;
  background: var(--GLS-white);
  box-shadow: 0 0.0625em 0.15625em rgba(158, 24, 24, 0.15);
  position: relative;
  left: 0;
  right: 0;
  z-index: 9999;
  overflow-y: auto;
  box-sizing: border-box;
}

.combobox-styled .v-list-item {
  margin: 0;
  list-style: none;
  cursor: pointer;
  padding: 0em 0.5em;
  border: 0.0625em solid #ddd;
  border-bottom-width: 0;
}
.combobox-styled .v-list-item__title {
  font-size: 8pt !important;
  color: black !important;
}

.combobox-styled .v-list-item--active {
  background: var(--GLS-blue-10);
  /* color: transparent !important; */
}

.combobox-styled .v-list-item:hover {
  background: var(--GLS-blue-10);
  /* color: transparent !important; */
}

/* tooltips */
.v-tooltip__content {
  background-color: var(--alt-blue) !important;
  /* background: linear-gradient(
    360deg,
    var(--GLS-blue-100) 0%,
    var(--gradient-blue) 143.9% 43.9%
  ) !important; */
  color: var(--GLS-white) !important;
  font-size: 8pt !important;
}

.v-tooltip__content.menuable__content__active {
  opacity: 1 !important; /* sets opacity of tooltips => no transparency */
}

/* pagination buttons */
.v-pagination__item,
/* .v-pagination .v-pagination__navigation, */
.v-pagination__navigation .v-icon {
  color: var(--alt-blue) !important;
  background-color: var(--GLS-white) !important;
  font-size: 8pt !important;
  min-height: 30px !important;
  max-height: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
}

.v-pagination .v-pagination__item--active,
.v-pagination__item:active /* onclick */ {
  color: var(--GLS-white) !important;
  background-color: var(--alt-blue) !important;
}

/* table */
.v-data-table > .v-data-table__wrapper > table > thead,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 8pt !important;
}
/* dialogs */
.v-dialog > .v-card > .v-card__text {
  font-size: 8pt !important;
}
</style>
